/// <reference path="./shims-hit-modules.d.ts" />

import {HitComponentsVuePlugin} from '@hit/components';
import {createApp} from 'vue';
import {i18n} from './plugins/i18n';
import VueMatomo from 'vue-matomo';
import App from './App.vue';
import './assets/tailwind.css';
import './styles/form-inputs.scss';
// import router from "./router";

const app = createApp(App);
app.use(HitComponentsVuePlugin);

app.use(VueMatomo, {
  host: 'https://matomo.ficos.com/',
  siteId: process.env.VUE_APP_MATOMO_SITE_ID,
});

// app.use(router)
app.use(i18n);
app.mount('#app');

window._paq = window._paq || [];
window._paq.push(['trackPageView']);
